/** 'YYYY-MM-DD' -> "Oct 15", for a WALL-CLOCK date with no time in it.
 *
 *  ⚠️ PARSED AT UTC NOON, AND THAT IS THE WHOLE POINT. A bare
 *  `new Date('2026-10-15')` is UTC midnight, which is Oct 14 anywhere west of
 *  Greenwich — this region included — so every date a coach, referee or
 *  operator reads would be a day early. Noon is far enough inside the day that
 *  no offset the region will ever see can cross it.
 *
 *  ⚠️ NOT NAMED `shortDate`, AND THE NAME IS THE POINT.
 *  `apps/admin-spa/src/lib/dates.ts` and `apps/workers/src/lib/dates.ts` both
 *  export a `shortDate` that renders the same "Oct 15" from a real ISO
 *  TIMESTAMP in the league time zone — a different rule taking a different
 *  input. Exporting a third `shortDate` from a package those apps already
 *  import would have put two rules behind one name in autocomplete, and this
 *  one turns a timestamp into the literal string "Invalid Date" rather than
 *  failing. Hand this one a date, hand those one a timestamp, and the names
 *  say which you meant.
 *
 *  It lives here because two surfaces need the wall-clock rule — coach-spa's
 *  practice slots and the stats SPA's Missing Cards filter — and a display
 *  rule copied into each surface drifts (`docs/traps-platform.md`).
 *  `coach-spa/src/lib/practiceDate.ts` keeps `shortDate` as a passthrough to
 *  this, and must never grow a rule of its own. */
export function wallClockDayLabel(d: string): string {
  return new Date(`${d}T12:00:00Z`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
